// Banda de "flow" del equipo: un LOTE de mensajes motivadores (generados por IA
// desde datos reales — merges, focos, PRs, momentum) que ROTAN al azar cada
// ~9s con animación de entrada, resaltados para leerlos y motivar. Cero humo:
// todo sale de lo trabajado (ver useFlow). data-source distingue IA de fallback.

import { useEffect, useState } from 'react'
import { Sparkles } from 'lucide-react'
import { useFlow } from '../queries'

// Intervalo de rotación entre mensajes del lote (override para tests).
function rotateMs(): number {
  try {
    const raw = Number(localStorage.getItem('wiphub_flow_rotate_ms'))
    if (Number.isFinite(raw) && raw > 0) return raw
  } catch {
    // ignore
  }
  return 9000
}

export function FlowBand() {
  const flow = useFlow()
  const count = flow.messages.length
  const [idx, setIdx] = useState(0)

  // Rotación ALEATORIA entre los mensajes del lote (nunca repite el actual).
  useEffect(() => {
    if (count <= 1) return
    const t = setInterval(() => {
      setIdx((cur) => {
        let n = cur
        while (n === cur) n = Math.floor(Math.random() * count)
        return n
      })
    }, rotateMs())
    return () => clearInterval(t)
  }, [count])

  const safeIdx = count > 0 ? idx % count : 0
  const msg = flow.messages[safeIdx] ?? ''

  return (
    <section
      data-testid="flow-band"
      data-source={flow.source}
      className="flex items-center gap-3 4k:gap-5 shrink-0 overflow-hidden border-b border-zinc-800 bg-gradient-to-r from-emerald-500/10 via-transparent to-transparent px-4 4k:px-8 py-1.5 4k:py-2"
    >
      <span
        data-testid="flow-state"
        className="flex items-center gap-1.5 shrink-0 rounded-full bg-emerald-500/15 px-2.5 py-0.5 text-[10px] 4k:text-xs font-bold uppercase tracking-wider text-emerald-300"
      >
        <Sparkles className="h-3 w-3 4k:h-4 4k:w-4" />
        {flow.state}
      </span>
      {/* La `key` (índice + inicio del mensaje) cambia en cada rotación → React
          re-monta el <p> → se replaya la animación wiphub-flow-in. */}
      <p
        key={`${safeIdx}-${msg.slice(0, 12)}`}
        data-testid="flow-message"
        className="wiphub-flow-in min-w-0 flex-1 truncate text-sm 4k:text-xl font-semibold text-zinc-100"
      >
        {msg}
      </p>
      {count > 1 && (
        <span data-testid="flow-progress" className="shrink-0 text-[10px] 4k:text-xs font-mono text-zinc-600 tabular-nums">
          {safeIdx + 1}/{count}
        </span>
      )}
    </section>
  )
}
